// component/policies/DataPrivacyPage.js
import React from "react";
import PolicyPageLayout from "./PolicyPageLayout";


const DataPrivacyPage = () => (
  <PolicyPageLayout title="Data Privacy and Protection">
    <p><strong>Last Updated:</strong> June 2025</p>


    <h2>1. Introduction</h2>
    <p>This Data Privacy and Protection Policy describes how THURENT TECH SERVICES PRIVATE LIMITED ("Thurent") collects, uses, stores, and protects personal data in compliance with applicable data protection laws including the Digital Personal Data Protection Act, 2023 (India).</p>


    <h2>2. Data We Collect</h2>
    <ul>
      <li><strong>Identity Data:</strong> Name, email, phone number, profile photo</li>
      <li><strong>Business Data:</strong> Business name, address, service details (for providers)</li>
      <li><strong>Event Data:</strong> Event details, guest lists, RSVP responses</li>
      <li><strong>Transaction Data:</strong> Payment information, order history</li>
      <li><strong>Technical Data:</strong> IP address, device information, app version</li>
      <li><strong>Location Data:</strong> Geographic location for service matching</li>
    </ul>


    <h2>3. Purpose of Data Processing</h2>
    <ul>
      <li>Providing and improving our services</li>
      <li>Matching users with service providers</li>
      <li>Processing payments and transactions</li>
      <li>Sending notifications and communications</li>
      <li>Ensuring platform safety and compliance</li>
      <li>Legal obligations and dispute resolution</li>
    </ul>


    <h2>4. Data Storage and Security</h2>
    <p>All personal data is stored on secure servers with encryption at rest and in transit. We implement industry-standard security measures including:</p>
    <ul>
      <li>AES-256 encryption for sensitive data</li>
      <li>SSL/TLS for all data transmission</li>
      <li>Regular security audits and penetration testing</li>
      <li>Access controls and role-based permissions</li>
    </ul>


    <h2>5. Data Retention</h2>
    <p>Personal data is retained only for as long as necessary to fulfill the purposes for which it was collected, or as required by applicable laws. Upon account deletion, personal data is anonymized or deleted within 90 days.</p>


    <h2>6. Your Rights</h2>
    <ul>
      <li><strong>Right to Access:</strong> Request a copy of your personal data</li>
      <li><strong>Right to Correction:</strong> Request correction of inaccurate data</li>
      <li><strong>Right to Erasure:</strong> Request deletion of your personal data</li>
      <li><strong>Right to Withdraw Consent:</strong> Withdraw consent at any time</li>
      <li><strong>Right to Grievance Redressal:</strong> File a complaint with our Data Protection Officer</li>
    </ul>


    <h2>7. Data Sharing</h2>
    <p>We do not sell personal data. Data may be shared with:</p>
    <ul>
      <li>Service providers you engage with through the platform</li>
      <li>Payment processors for transaction completion</li>
      <li>Law enforcement when legally required</li>
      <li>Analytics providers (anonymized data only)</li>
    </ul>
  </PolicyPageLayout>
);


export default DataPrivacyPage;



